import { ErrorCode } from '@shared/utils/enums';
import { ErrorMessageStrategy } from '@shared/utils/interfaces';

import { aggregatorRequestFailedStrategy } from './aggregator-request-failed.constant';
import { changeOwnUserStatusStrategy } from './change-own-user-status.constant';
import { criticalScopesChangeStrategy } from './critical-scopes-change.constant';
import { domainConfigurationEmptyStrategy } from './domain-configuration-empty.constant';
import { forceUpdateNotificationsFailedStrategy } from './force-update-notifications-failed.constant';
import { operatorProductStatusChangingExceptionStrategy } from './operator-product-status-changing-exception.constant';
import { paymentMethodBoNameDuplicateStrategy } from './payment-method-bo-name-duplicate.constant';
import { serviceDoesntExistsStrategy } from './service-doesnt-exists.constant';
import { singleActiveProviderConstraintStrategy } from './single-active-provider-constraint.constant';
import { vendorAssignFailStrategy } from './vendor-assign-fail.constant';
import { workspaceOwnerAlreadyActiveStrategy } from './workspace-owner-already-active.constant';

export const ERROR_MESSAGE_STRATEGIES: Partial<Record<ErrorCode, ErrorMessageStrategy>> = {
  [ErrorCode.SERVICE_DOESNT_EXISTS]: serviceDoesntExistsStrategy,
  [ErrorCode.OperatorProductStatusChangingException]: operatorProductStatusChangingExceptionStrategy,
  [ErrorCode.VendorProviderAssignFailed]: vendorAssignFailStrategy,
  [ErrorCode.SingleActiveProviderConstraint]: singleActiveProviderConstraintStrategy,
  [ErrorCode.WorkspaceOwnerAlreadyActive]: workspaceOwnerAlreadyActiveStrategy,
  [ErrorCode.AggregatorRequestFailed]: aggregatorRequestFailedStrategy,
  [ErrorCode.CannotChangeOwnStatus]: changeOwnUserStatusStrategy,
  [ErrorCode.CriticalScopesChange]: criticalScopesChangeStrategy,
  [ErrorCode.DomainConfigurationEmpty]: domainConfigurationEmptyStrategy,
  [ErrorCode.PaymentMethodBoNameDuplicate]: paymentMethodBoNameDuplicateStrategy,
  [ErrorCode.ForceUpdateNotificationsFailed]: forceUpdateNotificationsFailedStrategy,
};
